"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCandidate = useCandidate;
exports.useCandidateAnswerComparison = useCandidateAnswerComparison;
exports.useHasDirectAnswers = useHasDirectAnswers;
const react_1 = require("react");
const stores_1 = require("../stores/index.js");
const view_models_1 = require("../../view-models/index.js");
function useCandidate(id) {
    const candidates = (0, stores_1.useCalculatorStore)((state) => state.data.candidates);
    const persons = (0, stores_1.useCalculatorStore)((state) => state.data.persons);
    const organizations = (0, stores_1.useCalculatorStore)((state) => state.data.organizations);
    const baseUrl = (0, stores_1.useCalculatorStore)((state) => state.baseUrl);
    const personsMap = (0, react_1.useMemo)(() => new Map(persons?.map((p) => [p.id, (0, view_models_1.personViewModel)(p, baseUrl)]) ?? []), [persons, baseUrl]);
    const organizationsMap = (0, react_1.useMemo)(() => new Map(organizations?.map((o) => [o.id, (0, view_models_1.organizationViewModel)(o, baseUrl)]) ?? []), [organizations, baseUrl]);
    return (0, react_1.useMemo)(() => {
        const candidate = candidates.find((candidate) => candidate.id === id);
        return candidate ? (0, view_models_1.candidateViewModel)(candidate, personsMap, organizationsMap, baseUrl) : undefined;
    }, [candidates, personsMap, organizationsMap, id, baseUrl]);
}
function useCandidateAnswerComparison(candidateId) {
    const userAnswers = (0, stores_1.useAnswersStore)((state) => state.answers);
    const candidatesAnswers = (0, stores_1.useCalculatorStore)((state) => state.data.candidatesAnswers);
    const questions = (0, stores_1.useCalculatorStore)((state) => state.data.questions);
    return (0, react_1.useMemo)(() => {
        return (0, view_models_1.getCandidateAnswerComparison)(candidateId, userAnswers, candidatesAnswers, questions);
    }, [candidateId, userAnswers, candidatesAnswers, questions]);
}
function useHasDirectAnswers(candidateId) {
    const candidatesAnswers = (0, stores_1.useCalculatorStore)((state) => state.data.candidatesAnswers);
    return (0, react_1.useMemo)(() => {
        return (0, view_models_1.hasDirectAnswers)(candidateId, candidatesAnswers);
    }, [candidateId, candidatesAnswers]);
}
